import React from 'react';

// Trigram component for reuse
const Trigram: React.FC<{ bars: (0 | 1)[]; x: number; y: number; barWidth?: number; barHeight?: number; gap?: number }> =
  ({ bars, x, y, barWidth = 60, barHeight = 15, gap = 8 }) => (
  <g transform={`translate(${x}, ${y})`}>
    {bars.map((bar, i) => (
      bar === 1 ?
        <rect key={i} y={i * (barHeight + gap)} width={barWidth} height={barHeight} fill="#000000" /> :
        <g key={i}>
          <rect y={i * (barHeight + gap)} width={(barWidth / 2) - (gap / 2)} height={barHeight} fill="#000000" />
          <rect x={(barWidth / 2) + (gap / 2)} y={i * (barHeight + gap)} width={(barWidth / 2) - (gap / 2)} height={barHeight} fill="#000000" />
        </g>
    ))}
  </g>
);


export const FlagKRIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 900 600" // Standard 3:2 ratio
    {...props}
  >
    <rect width="900" height="600" fill="#FFFFFF" rx="2" stroke="#D1D5DB" strokeWidth="5"/> {/* White background with subtle border */}
    {/* Taegeuk (yin-yang symbol) */}
    <g transform="translate(450 300)"> {/* Center the Taegeuk */}
      <circle r="150" fill="#CD2E3A" /> {/* Red (yang) part */}
      <path d="M0 -150 A150 150 0 0 0 0 150 A75 75 0 0 1 0 -150 A75 75 0 0 0 0 150 Z" fill="#0047A0" /> {/* Blue (yin) part */}
    </g>

    {/* Trigrams settings */}
    {(() => {
      const trigramSettings = { barWidth: 100, barHeight: 20, gap: 10 };
      const trigramDistX = 220; // Distance from center horizontally
      const trigramDistY = 110; // Distance from center vertically

      return (
        <>
          {/* Geon (☰) - Top-left */}
          <Trigram bars={[1,1,1]} x={450 - trigramDistX - trigramSettings.barWidth} y={300 - trigramDistY - (trigramSettings.barHeight * 3 + trigramSettings.gap * 2)/2} {...trigramSettings} />
          {/* Ri (☲) - Bottom-left */}
          <Trigram bars={[1,0,1]} x={450 - trigramDistX - trigramSettings.barWidth} y={300 + trigramDistY - (trigramSettings.barHeight * 3 + trigramSettings.gap * 2)/2} {...trigramSettings} />
          {/* Gam (☵) - Top-right */}
          <Trigram bars={[0,1,0]} x={450 + trigramDistX} y={300 - trigramDistY - (trigramSettings.barHeight * 3 + trigramSettings.gap * 2)/2} {...trigramSettings} />
          {/* Gon (☷) - Bottom-right */}
          <Trigram bars={[0,0,0]} x={450 + trigramDistX} y={300 + trigramDistY - (trigramSettings.barHeight * 3 + trigramSettings.gap * 2)/2} {...trigramSettings} />
        </>
      );
    })()}
  </svg>
);